<template>
  <page-component id="webaccountsettings" :header="header">
    <form ref="form" class="novalidate" :action="baseHref + 'account.html'" method="post" @submit.prevent="onSubmit()">
      <input type="hidden" name="Action" value="process" />
      <input type="hidden" name="SubAction" value="" />
      <input type="hidden" name="_csrf_token" :value="crsf" />
      <input v-if="isInvite" type="hidden" name="invitid" :value="inviteid" />

      <ValidationObserver ref="obs1" v-slot="{ invalid }" slim>
        <group-component header="Account Details">
          <ValidationProvider rules="required" name="Username" v-slot="{ errors }" mode="eager" slim>
            <fillin-component
              id="webaccount_username"
              label="Username:"
              type="text"
              formInputName="webaccount_username"
              v-model="internalUsername"
              :max-length="100"
              :errorMessages="errors"
              required
              newline>
            </fillin-component>
          </ValidationProvider>

          <ValidationProvider rules="required|email" name="Email" v-slot="{ errors }" mode="eager" slim>
            <fillin-component
              id="webaccount_email"
              label="Email:"
              type="text"
              formInputName="webaccount_email"
              v-model="internalEmail"
              :max-length="100"
              :errorMessages="errors"
              required
              newline>
            </fillin-component>
          </ValidationProvider>

          <checkbox-component
            id="webaccount_optin"
            label="Subscribe to Future Marketing Communications?"
            formInputName="webaccount_optin"            
            v-model="internalOptIn"
            labelRight
            newline
            ></checkbox-component>

          <button
            v-if="!isInvite"
            id="webaccountmanagement_buttonchangedetails"
            type="button"
            class="button primary"
            :disabled="invalid || processing"
            @click.prevent="onSubmitDetails()"
            >
            Update Details
          </button>         
        </group-component>
      </ValidationObserver>

      <ValidationObserver ref="obs2" v-slot="{ invalid }" slim>
        <group-component header="Account Password" :collapsible="!isInvite" :collapsed="!isInvite">
          <ValidationProvider v-if="!isInvite" rules="required" name="Existing Password" v-slot="{ errors }" mode="eager" slim>
            <fillin-component
              id="webaccount_password"
              label="Existing Password:"
              type="password"
              formInputName="webaccount_password"
              v-model="internalPassword"
              :errorMessages="errors"
              required
              newline>
            </fillin-component>      
          </ValidationProvider>

          <ValidationProvider vid="newpassword" rules="required" name="Password" v-slot="{ errors }" mode="eager" slim>  
            <fillin-component
              id="webaccount_newpassword1"
              :label="isInvite ? 'Password:' : 'New Password:'"
              type="password"
              formInputName="webaccount_newpassword1"
              v-model="internalNewPassword1"
              :errorMessages="errors"
              required
              newline>
            </fillin-component>
          </ValidationProvider>

          <ValidationProvider rules="required|confirmed:newpassword" name="Confirm Password" v-slot="{ errors }" mode="eager" slim>
            <fillin-component
              id="webaccount_newpassword2"
              :label="isInvite ? 'Confirm Password:' : 'Confirm New Password:'"
              type="password"
              formInputName="webaccount_newpassword2"
              v-model="internalNewPassword2"
              :errorMessages="errors"
              required
              newline>
            </fillin-component>
          </ValidationProvider>

          <button
            v-if="!isInvite"
            id="webaccountmanagement_buttonchangepassword"
            type="button"
            class="button primary"
            :disabled="invalid || processing"
            @click.prevent="onSubmitPassword()"
            >
            Change Password
          </button>        
        </group-component>  
      </ValidationObserver>   

      <group-component v-if="isInvite">
        <button
          id="webaccountmanagement_buttoncreate"
          type="button"
          class="button primary"
          :disabled="processing"
          @click.prevent="onSubmitAll()"
          >
          Create Account
        </button>    
      </group-component>
    </form> 
  </page-component>
</template>

<script>
export default {
  name: "AccountSettings",
  props: {
    firstname: String,
    username: String,
    email: String,
    inviteid: String,
    optin: Boolean,
  },
  data() {
    return {
      header: "",
      crsf: App.settings.CSRFToken,
      baseHref: App.settings.BaseHref,
      internalUsername: "",
      internalEmail: "",
      internalPassword: "",
      internalNewPassword1: "",
      internalNewPassword2: "",
      internalOptIn: false,
      processing: false,
      isInvite: false,
    };
  },
  created() {
    this.isInvite = this.inviteid ? true : false;
    this.header = this.isInvite ? "Create New Account" : `My Profile for ${this.firstname}`;
    this.internalUsername = this.username;
    this.internalEmail = this.email;
    this.internalOptIn = this.optin;
  },
  methods: {
    async onSubmitDetails() {
      const valid = await this.$refs.obs1.validate();
      if (!valid) {
        return;
      }

      this.submitForm();
    },

    async onSubmitPassword() {
      const valid = await this.$refs.obs2.validate();
      if (!valid) {
        return;
      }

      this.submitForm();
    },
    
    async onSubmitAll() {
      const valid1 = await this.$refs.obs1.validate();
      if (!valid1) {
        return;
      }

      const valid2 = await this.$refs.obs2.validate();
      if (!valid2) {
        return;
      }      

      this.submitForm();
    },

    submitForm() {
      this.processing = true;
      this.$refs.form.submit(); // Use to submit form after checks
    }
  }
}
</script>
